angular.module('core')
    .component('notesEditor', {
        bindings: {
            value: '=',
            onSave: '&?',
            maxLength: '<?',
            rows: '<?',
            compact: '<?',
            showWarningIcon: '<?'
        },
        template: `
            <span class="notes-editor"
                  ng-class="{'is-empty': !$ctrl.value, 'notes-editor--compact': $ctrl.compact, 'notes-editor--with-warning': $ctrl.showWarningIcon && $ctrl.value}"
                  editable-textarea="$ctrl.value"
                  e-empty-to-null
                  e-maxlength="{{$ctrl.maxLength}}"
                  e-rows="{{$ctrl.rows}}"
                  e-formclass="editable-block-inputs notes-editor-form"
                  onbeforesave="$ctrl.save($data)">
                <span class="notes-editor__warning" ng-if="$ctrl.showWarningIcon && $ctrl.value">
                    <i class="fa fa-fw fa-lg fa-exclamation-triangle warning-icon"></i>
                </span>
                <span class="notes-editor__text" ng-if="$ctrl.value">{{$ctrl.value}}</span>
                <span class="notes-editor__empty" ng-if="!$ctrl.value"><i class="fa fa-fw fa-pencil"></i></span>
            </span>
        `,
        controller: function () {
            this.$onInit = () => {
                this.maxLength = this.maxLength || 1000
                this.rows = this.rows || 3
            }

            this.save = data => angular.isFunction(this.onSave) ? this.onSave({$data: data}) : data
        }
    })
